import { Service } from '@/tools'
export class contractCommodityListService<T extends TContract.TContractCommodityList['CommodityList']> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(
    url: `${P}/${keyof TContract.TContractCommodityList['CommodityList']}`,
    data?: TCommon.Json,
    toast?: string
  ) {
    return this.post(url, data, toast)
  }
  //获取商品清单
  unitizationGetList = <K extends T['ApiGetList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiGetList', data)
  // 联营商品清单分页查询--/api/contract/commodityList/v1/pageList
  unitizationPage = <K extends T['ApiPageList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageList', data)
  // 新增联营商品清单--/api/contract/commodityList/v1/add
  addUnitization = <K extends T['ApiAdd']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiAdd', data)
  // 更新联营商品清单--/api/contract/commodityList/v1/update
  updateUnitization = <K extends T['ApiUpdate']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiUpdate', data)
  // 联营商品清单详情--/api/contract/commodityList/v1/query
  unitizationDetail = <K extends T['ApiQuery']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiQuery', data)
  // 删除联营商品清单--/api/contract/commodityList/v1/delete
  deleteUnitization = <K extends T['ApiDelete']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiDelete', data)
}
